import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { FormattedNumber } from 'react-intl';
import moment from 'moment';
import Calendar from '../../../api/api-calendar';
import { Spinner } from 'shared-components/decorators/spinner';

import AttendeePricingTable from './attendee-pricing-table';
import TableRow from './table-row';
import IntlProviderHOC from '../app-main/containers/IntlProviderHOC';

export default class VariablePricingTable extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      showSpinner: false,
      error: '',
      pricesByGroup: []
    };
  }

  componentDidMount () {
    this.setState({ showSpinner: true });
    const listingId = get(this.props, 'listing._id', '') || get(this.props, 'listing.listing_id', '');
    Calendar.readCalendarV2(listingId, PSSessions.Cookies('PSAccess'),
      res => {
        const pricesByGroup = get(res, 'prices_by_group', []);
        if (200 === res.statusCode) {
          const calendarPricing = get(this.props, 'rateDetails.calendar_pricing', {});
          const location = window.location.pathname.slice(1).split('/')[0];
          const pageLocation = () => {
            switch (location) {
            case 'pages':
              return 'listing';
            case 'bkc':
              return 'booking request';
            default:
              return location;
            }
          };
          if (window.analyticsIntegrations) {
            analyticsIntegrations.calendarPricingAction('viewed_rate_detail_modal',
              Object.assign({},
                { page_type: pageLocation(),
                  listing_id: listingId,
                  bkg_has_price_by_day: (this.props.rateDetails || {}).is_rate_variable,
                  hourly_rate: calendarPricing.calendar_hourly_price,
                  subtotal_amount: calendarPricing.total_price
                }));
          }

          return this.setState({ showSpinner: false, pricesByGroup });
        }
        const error = get(res, 'error', '');
        return this.setState({ showSpinner: false, error });
      }
    );
  }

  render () {
    const { showSpinner, pricesByGroup, error } = this.state;
    const { listing } = this.props;
    const currency = get(listing, 'prices.0.currency', 'USD');
    const price = get(listing, 'prices.0.value', 0);

    return (
      <IntlProviderHOC>
        <div>
          { showSpinner
            ? <Spinner additionalStyle="gray" />
            : (
              <div className="VariablePricingTable container-fluid">
                <div className="row">
                  <div className="col-sm-10 col-sm-offset-1">
                    <h5>Hourly Rates</h5>
                    <hr className="pricing-table-border" />
                    <TableRow
                      leftCol={
                        <div>
                          <div className="heavy">Base rate</div>
                        </div>
                      }
                      rightCol={
                        <div>
                          <FormattedNumber
                            value={price}
                            currency={currency}
                            style="currency"
                            minimumFractionDigits={0}
                            maximumFractionDigits={0}
                          />/hr
                        </div>
                      }
                    />
                    <hr className="pricing-table-border" />
                    { error &&
                      <div className="text-danger text-center">
                        Something happened. Please refresh and try again later.
                      </div>
                    }
                    {
                      pricesByGroup.length ?
                        pricesByGroup.map((calPrice) => {
                          const dows = get(calPrice, 'dows', []);
                          const dowStrings = dows.map(dow => moment().isoWeekday(dow).format('ddd')).join(', ');

                          return (
                            <div>
                              <TableRow
                                key={calPrice.group_id}
                                leftCol={
                                  <div>
                                    <div className="heavy">{calPrice.name}</div>
                                    <div className="text-small text-gray-dark">
                                      <div>
                                        {dowStrings}
                                      </div>
                                      <div>
                                        {calPrice.time_interval_string}
                                      </div>
                                    </div>
                                  </div>
                                }
                                rightCol={
                                  <div>
                                    <FormattedNumber
                                      value={calPrice.hourly_rate || 0}
                                      currency={currency}
                                      style="currency"
                                      minimumFractionDigits={0}
                                      maximumFractionDigits={0}
                                    />/hr
                                  </div>
                                }
                              />
                              <hr className="pricing-table-border" />
                            </div>
                          );
                        }) : null
                    }
                    <AttendeePricingTable listing={this.props.listing} />
                  </div>
                </div>
              </div>
            )
          }
        </div>
      </IntlProviderHOC>
    );
  }
}

VariablePricingTable.propTypes = {
  listing: PropTypes.object.isRequired,
  rateDetails: PropTypes.object.isRequired
};
